import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const StyledForm = styled.div`
    height: auto;
    max-width: 434px;
    margin-top: 1.5rem;

    @media (min-width: ${theme.breakpoints[2]}) {
        margin-top: 2rem;
    }

    .form__login {
        margin-top: 1.125rem;

        > .form__login__field {
            height: auto;
            margin-bottom: 1.5rem;
        }
    }

    form {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        height: 100%;
    }

    .form__helper-button {
        display: flex;
        justify-content: flex-end;
        cursor: pointer;

        span {
            color: ${theme.colors.grays[50]};
            font-size: 12px;
            padding: 4px;
        }
    }

    .form__subtitle {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 32px 0;
        font-size: 14px;
    }

    .form__subtitle__link {
        width: auto;
        text-align: center;
    }

    button {
        width: 100%;
    }

    .cipHelp {
        border-width: 1.5px;
        border-style: solid;
        border-color: ${theme.colors.primary};
        border-radius: 5px;
        padding: 16px;
        text-align: center;
        height: 50px;
        overflow: hidden;
        cursor: pointer;
        transition: 0.5s ease height;
        font-weight: 600;
        &.openButton {
            height: max-content;
        }
        .helpText {
            font-weight: 400;
            margin-top: 14px;
        }
    }
    .form__login__field > span {
        display: block;
        font-size: 1rem;
        line-height: 1rem;
        padding-bottom: 6px;
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        .cipHelp {
            width: 434px;
            height: 58px;
            &.openButton {
                height: max-content;
            }
        }
        .form__login {
            margin-bottom: 8px;
        }

        form {
            display: initial;
            height: initial;
        }
    }
`

export const WrapperDropDown = styled.div<{ rotate: boolean }>`
    margin-top: 16px;
    svg {
        color: ${theme.colors.primary};
        transform: rotate(${({ rotate }) => (rotate ? '0deg' : '180deg')}) !important;
        transition: transform 0.2s linear;
        float: right;
        position: relative;
        top: 3px;
    }
`
